import React, {useEffect, useState} from 'react';
import ReservationMaterialEstimateUnitTable
    from "../../../../components/UI/table/warehouse/reservation/ReservationMaterialEstimateUnitTable";
import {useLocation, useParams} from "react-router-dom";
import {Box, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import MaterialReserveService from "../../../../API/orders/reservation/MaterialReserveService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {materialReserveState} from "../../../../data/MaterialReserveState";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";

const ReservationMaterialEstimateUnitPurchase = () => {
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [rowSelection, setRowSelection] = useState([]);
    const [openSelection, setOpenSelection] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const pathname = useLocation().pathname

    const params = useParams();

    const {
        materialEstimateUnitId,
        estimateId,
        estimateState,
        orderId,
        orderNumber,
        orderHeaderId,
        year,
        isButtonPurchase,
        isSlab,
        articleNumber,
        type,
        name,
        isIssue,
        status,
        baseUnit,
    } = params
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }


    useEffect(() => {
        getStartPageSize()
        MaterialReserveService.getAllByMaterialEstimateUnitId(type, materialEstimateUnitId).then(function (response) {
            const data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const modalActions = [
        {name: "Отправить на закупку", type: "setPurchase"},
    ]

    const handleSetPurchase = () => {
        MaterialReserveService.setPurchaseByIds(rowSelection)
            .then(function () {
                setData(prev => prev.map(el => rowSelection.includes(el.id) ? {
                    ...el,
                    materialReserveState: "PURCHASE"
                } : el))
                setOpenSelection(false)
                setRowSelection([])
                handleModalAlert("Отправлено на закупку", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Резервы"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заявки на закупку", href: "/organization/requests-purchase"},
                    {
                        name: `Заявка на заказ ${orderNumber}`,
                        href: "/organization/requests-purchase/" + estimateId + '/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + estimateState
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервы
                    </Typography>
                    <Typography>{`Арикул: ${articleNumber === "null" ? "" : articleNumber}`}</Typography>
                    <Typography>{`Наименование: ${name}`}</Typography>
                    <Typography>{`Статус: ${materialReserveState[status]}`}</Typography>
                </Box>
                <ReservationMaterialEstimateUnitTable
                    data={data}
                    setData={setData}
                    orderId={orderId}
                    nameOrder={orderNumber}
                    orderHeaderId={orderHeaderId}
                    year={year}
                    estimateId={estimateId}
                    isButtonPurchase={false}
                    isSlab={isSlab}
                    isColumnOrder={false}
                    isIssue={isIssue === "true"}
                    enableEditing={true}
                    materialEstimateUnitId={materialEstimateUnitId}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    status={status}
                    enableRowSelection={true}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    baseUnit={baseUnit}
                    nameMaterial={name}
                    articleNumber={articleNumber}
                    estimateState={estimateState}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpenSelection(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={openSelection}
                    reset={() => setOpenSelection(false)}
                    submit={handleSetPurchase}
                    modalActions={modalActions}
                />
                <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                    return {...alert, open: false}
                })}/>
            </Box>
        </Box>
    );
};

export default ReservationMaterialEstimateUnitPurchase;